var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 105,
    height: 105,
    rx: 52.5,
    fill: "#934CFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3332 53.0002V83.4168H28.6666V53.0002M52.9999 83.4168V37.7918M52.9999 37.7918H39.3124C37.2957 37.7918 35.3615 36.9907 33.9355 35.5646C32.5094 34.1386 31.7083 32.2044 31.7083 30.1877C31.7083 28.1709 32.5094 26.2368 33.9355 24.8107C35.3615 23.3846 37.2957 22.5835 39.3124 22.5835C49.9583 22.5835 52.9999 37.7918 52.9999 37.7918ZM52.9999 37.7918H66.6874C68.7042 37.7918 70.6383 36.9907 72.0644 35.5646C73.4904 34.1386 74.2916 32.2044 74.2916 30.1877C74.2916 28.1709 73.4904 26.2368 72.0644 24.8107C70.6383 23.3846 68.7042 22.5835 66.6874 22.5835C56.0416 22.5835 52.9999 37.7918 52.9999 37.7918ZM22.5833 37.7918H83.4166V53.0002H22.5833V37.7918Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSvg);
export default __webpack_public_path__ + "static/media/giftSvg.cf2f65a144ce3444f69d586514032dc6.svg";
export { ForwardRef as ReactComponent };